import { render } from "./BaseTasksAndEvents.vue?vue&type=template&id=206cd0ef&scoped=true"
import script from "./BaseTasksAndEvents.vue?vue&type=script&lang=js"
export * from "./BaseTasksAndEvents.vue?vue&type=script&lang=js"

import "./BaseTasksAndEvents.vue?vue&type=style&index=0&id=206cd0ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206cd0ef"]])

export default __exports__